import { render, staticRenderFns } from "./u-btn-flat-tile.vue?vue&type=template&id=24aef6c6&scoped=true"
import script from "./u-btn-flat-tile.vue?vue&type=script&lang=js"
export * from "./u-btn-flat-tile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aef6c6",
  null
  
)

export default component.exports